import { useEffect, useState } from 'react'

const useHorizontalIndicator = (isHorizontal, containerEl, contentEl) => {
  const [isShowLeftScrollMoreIndicator, setIsShowLeftScrollMoreIndicator] =
    useState(false)
  const [isShowRightScrollMoreIndicator, setIsShowRightScrollMoreIndicator] =
    useState(false)

  useEffect(() => {
    if (!isHorizontal) {
      return undefined
    }
    const updateScrollMoreIndicator = () => {
      const searchResultListTargetEl = containerEl.current
      if (!searchResultListTargetEl) {
        return null
      }
      const rect = searchResultListTargetEl.getBoundingClientRect()
      const listTargetEl = contentEl.current
      const listTargetElWidth = listTargetEl.clientWidth
      const { scrollLeft } = searchResultListTargetEl
      const visibleRight = rect.width + scrollLeft

      // left
      if (isShowLeftScrollMoreIndicator === false && scrollLeft >= 5) {
        setIsShowLeftScrollMoreIndicator(true)
      } else if (isShowLeftScrollMoreIndicator === true && scrollLeft < 5) {
        setIsShowLeftScrollMoreIndicator(false)
      }

      // right
      if (
        isShowRightScrollMoreIndicator === false &&
        visibleRight < listTargetElWidth
      ) {
        setIsShowRightScrollMoreIndicator(true)
      } else if (
        isShowRightScrollMoreIndicator === true &&
        visibleRight >= listTargetElWidth
      ) {
        setIsShowRightScrollMoreIndicator(false)
      }
    }

    const initialise = () => {
      const searchResultListTargetEl = containerEl.current
      if (searchResultListTargetEl) {
        updateScrollMoreIndicator()
        searchResultListTargetEl.addEventListener(
          'scroll',
          updateScrollMoreIndicator
        )
      } else {
        setTimeout(initialise, 500)
      }
    }
    setTimeout(initialise, 500)

    return () => {
      const searchResultListTargetEl = containerEl.current
      if (searchResultListTargetEl) {
        searchResultListTargetEl.removeEventListener(
          'scroll',
          updateScrollMoreIndicator
        )
      }
    }
  }, [
    containerEl,
    contentEl,
    isHorizontal,
    isShowLeftScrollMoreIndicator,
    isShowRightScrollMoreIndicator,
  ])
  return [isShowLeftScrollMoreIndicator, isShowRightScrollMoreIndicator]
}

export { useHorizontalIndicator }
